function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconVoiceInputRexOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26 16h-2a8 8 0 01-16 0H6c0 5.186 3.947 9.447 9 9.949V28h-3v2h8v-2h-3v-2.051c5.053-.502 9-4.763 9-9.949z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 8c0-2.205 1.794-4 4-4s4 1.795 4 4v8c0 2.205-1.794 4-4 4s-4-1.795-4-4V8zm4 14a6 6 0 006-6V8a6 6 0 00-12 0v8a6 6 0 006 6z",
    fill: props.color
  }));
}

export default SvgIconVoiceInputRexOutline;